var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bd-head"},[_vm._m(0),_c('Nav')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../../assets/LG.png")}}),_vm._v(" 通航飞行管控系统 ")])
}]

export { render, staticRenderFns }